"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/* eslint-disable no-param-reassign */
var CRC32 = require('crc-32');
var store = require('./store');
var purchaseEventStorageKey = '_constructorio_purchase_order_ids';
var PII_REGEX = [{
  pattern: /[\w\-+\\.]+@([\w-]+\.)+[\w-]{2,4}/,
  replaceWith: '<email_omitted>'
}, {
  pattern: /^(?:\+\d{11,12}|\+\d{1,3}\s\d{3}\s\d{3}\s\d{3,4}|\(\d{3}\)\d{7}|\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\d{3}-\d{4}|\(\d{3}\)\s\d{3}-\d{4})$/,
  replaceWith: '<phone_omitted>'
}, {
  pattern: /^(?:4[0-9]{15}|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
  // Visa, Mastercard, Amex, Discover, JCB and Diners Club, regex source: https://www.regular-expressions.info/creditcard.html
  replaceWith: '<credit_omitted>'
}
// Add more PII REGEX
];

var utils = {
  trimNonBreakingSpaces: function trimNonBreakingSpaces(string) {
    return string.replace(/\s/g, ' ').trim();
  },
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
  encodeURIComponentRFC3986: function encodeURIComponentRFC3986(string) {
    return encodeURIComponent(string).replace(/[!'()*]/g, function (c) {
      return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
    });
  },
  cleanParams: function cleanParams(paramsObj) {
    var cleanedParams = {};
    Object.keys(paramsObj).forEach(function (paramKey) {
      var paramValue = paramsObj[paramKey];
      if (typeof paramValue === 'string') {
        // Replace non-breaking spaces (or any other type of spaces caught by the regex)
        // - with a regular white space
        cleanedParams[paramKey] = utils.trimNonBreakingSpaces(paramValue);
      } else {
        cleanedParams[paramKey] = paramValue;
      }
    });
    return cleanedParams;
  },
  throwHttpErrorFromResponse: function throwHttpErrorFromResponse(error, response) {
    return response.json().then(function (json) {
      error.message = json.message;
      error.status = response.status;
      error.statusText = response.statusText;
      error.url = response.url;
      error.headers = response.headers;
      throw error;
    });
  },
  canUseDOM: function canUseDOM() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  },
  addEventListener: function addEventListener(eventType, callback, useCapture) {
    if (utils.canUseDOM()) {
      window.addEventListener(eventType, callback, useCapture);
    }
  },
  removeEventListener: function removeEventListener(eventType, callback, useCapture) {
    if (utils.canUseDOM()) {
      window.removeEventListener(eventType, callback, useCapture);
    }
  },
  getNavigator: function getNavigator() {
    if (utils.canUseDOM()) {
      return window.navigator;
    }
    return {
      userAgent: '',
      webdriver: false
    };
  },
  isNil: function isNil(value) {
    return value == null;
  },
  getWindowLocation: function getWindowLocation() {
    if (utils.canUseDOM()) {
      return window.location;
    }
    return {};
  },
  dispatchEvent: function dispatchEvent(event) {
    if (utils.canUseDOM()) {
      window.dispatchEvent(event);
    }
  },
  createCustomEvent: function createCustomEvent(eventName, detail) {
    if (utils.canUseDOM()) {
      try {
        return new window.CustomEvent(eventName, {
          detail: detail
        });
      } catch (e) {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(eventName, false, false, detail);
        return evt;
      }
    }
    return null;
  },
  hasOrderIdRecord: function hasOrderIdRecord(_ref) {
    var orderId = _ref.orderId,
      apiKey = _ref.apiKey;
    var orderPerKeyId = orderId;
    if (apiKey) orderPerKeyId = "".concat(apiKey, "-").concat(orderId);
    var orderIdHash = CRC32.str(orderPerKeyId.toString());
    var purchaseEventStorage = store.local.get(purchaseEventStorageKey);
    if (typeof purchaseEventStorage === 'string') {
      purchaseEventStorage = JSON.parse(purchaseEventStorage);
    }
    if (purchaseEventStorage && purchaseEventStorage.includes(orderIdHash)) {
      return true;
    }
    return null;
  },
  addOrderIdRecord: function addOrderIdRecord(_ref2) {
    var orderId = _ref2.orderId,
      apiKey = _ref2.apiKey;
    var orderPerKeyId = orderId;
    if (apiKey) orderPerKeyId = "".concat(apiKey, "-").concat(orderId);
    var orderIdHash = CRC32.str(orderPerKeyId.toString());
    var purchaseEventStorage = store.local.get(purchaseEventStorageKey);
    if (typeof purchaseEventStorage === 'string') {
      purchaseEventStorage = JSON.parse(purchaseEventStorage);
    }
    if (purchaseEventStorage) {
      // If the order already exists, do nothing
      if (purchaseEventStorage.includes(orderIdHash)) {
        return;
      }
      if (purchaseEventStorage.length >= 10) {
        purchaseEventStorage = purchaseEventStorage.slice(-9);
      }
      purchaseEventStorage.push(orderIdHash);
    } else {
      // Create a new object map for the order ids
      purchaseEventStorage = [orderIdHash];
    }

    // Push the order id map into local storage
    store.local.set(purchaseEventStorageKey, purchaseEventStorage);
  },
  // Abort network request based on supplied timeout interval (in milliseconds)
  // - method call parameter takes precedence over global options parameter
  applyNetworkTimeout: function applyNetworkTimeout() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var controller = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var optionsTimeout = options && options.networkParameters && options.networkParameters.timeout;
    var networkParametersTimeout = networkParameters && networkParameters.timeout;
    var timeout = networkParametersTimeout || optionsTimeout;
    if (typeof timeout === 'number' && controller) {
      setTimeout(function () {
        return controller.abort();
      }, timeout);
    }
  },
  stringify: function stringify(object, prefix, objectType) {
    if (!object) {
      return '';
    }
    var allValues = [];
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      var encodedKey = utils.encodeURIComponentRFC3986(key);
      var stringifiedValue;

      // Check for both null and undefined
      if (value != null) {
        var nextPrefix = prefix ? "".concat(prefix, "%5B").concat(encodedKey, "%5D") : encodedKey;
        if (Array.isArray(value)) {
          stringifiedValue = utils.stringify(value, nextPrefix, 'array');
        } else if ((0, _typeof2["default"])(value) === 'object') {
          stringifiedValue = utils.stringify(value, nextPrefix, 'object');
        } else if (objectType === 'object') {
          stringifiedValue = "".concat(nextPrefix, "=").concat(utils.encodeURIComponentRFC3986(value));
        } else {
          stringifiedValue = "".concat(prefix || encodedKey, "=").concat(utils.encodeURIComponentRFC3986(value));
        }
        allValues.push(stringifiedValue);
      }
    });
    return allValues.join('&');
  },
  toSnakeCase: function toSnakeCase(camelCasedStr) {
    return camelCasedStr.replace(/[A-Z]/g, function (prefix) {
      return "_".concat(prefix.toLowerCase());
    });
  },
  toSnakeCaseKeys: function toSnakeCaseKeys(camelCasedObj) {
    var toRecurse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var snakeCasedObj = {};
    Object.keys(camelCasedObj).forEach(function (key) {
      var newKey = utils.toSnakeCase(key);
      snakeCasedObj[newKey] = toRecurse && (0, _typeof2["default"])(camelCasedObj[key]) === 'object' && !Array.isArray(camelCasedObj[key]) ? utils.toSnakeCaseKeys(camelCasedObj[key], toRecurse) : camelCasedObj[key];
    });
    return snakeCasedObj;
  },
  containsPii: function containsPii(query, piiPattern) {
    var normalizedTerm = query.toLowerCase();
    return piiPattern.test(normalizedTerm);
  },
  obfuscatePiiRequest: function obfuscatePiiRequest(urlString) {
    var obfuscatedUrl = urlString;
    try {
      var _url$pathname, _url$search, _url$search$split;
      var url = new URL(urlString);
      var paths = url === null || url === void 0 ? void 0 : (_url$pathname = url.pathname) === null || _url$pathname === void 0 ? void 0 : _url$pathname.split('/');
      var paramValues = url === null || url === void 0 ? void 0 : (_url$search = url.search) === null || _url$search === void 0 ? void 0 : (_url$search$split = _url$search.split('&')) === null || _url$search$split === void 0 ? void 0 : _url$search$split.map(function (param) {
        var _param$split;
        return (_param$split = param.split('=')) === null || _param$split === void 0 ? void 0 : _param$split[1];
      });
      PII_REGEX.forEach(function (_ref3) {
        var pattern = _ref3.pattern,
          replaceWith = _ref3.replaceWith;
        paths.forEach(function (path) {
          var decodedPath = decodeURIComponent(path);
          if (utils.containsPii(decodedPath, pattern)) {
            obfuscatedUrl = obfuscatedUrl.replaceAll(path, replaceWith);
          }
        });
        paramValues.forEach(function (paramValue) {
          var decodedParamValue = decodeURIComponent(paramValue);
          if (utils.containsPii(decodedParamValue, pattern)) {
            obfuscatedUrl = obfuscatedUrl.replaceAll(decodedParamValue, replaceWith);
          }
        });
      });
    } catch (e) {
      // do nothing
    }
    return obfuscatedUrl;
  },
  convertResponseToJson: function convertResponseToJson(response) {
    if (response.ok) {
      return response.json()["catch"](function () {
        return response.text().then(function (responseText) {
          throw new Error("Server responded with an invalid JSON object. Response code: ".concat(response.code, ", Response: ").concat(responseText));
        });
      });
    }
    return utils.throwHttpErrorFromResponse(new Error(), response);
  },
  addHTTPSToString: function addHTTPSToString(url) {
    if (typeof url !== 'string') {
      return null;
    }
    var doesUrlIncludeHTTPS = url.startsWith('https://');
    var doesUrlStartWithHTTP = url.startsWith('http://');
    if (!doesUrlIncludeHTTPS && doesUrlStartWithHTTP) {
      return url.replace('http', 'https');
    }
    if (!doesUrlStartWithHTTP && !doesUrlIncludeHTTPS) {
      var urlWithHttps = "https://".concat(url);
      return urlWithHttps;
    }
    return url;
  }
};
module.exports = utils;